import { useEffect, useState } from "react";
import { Api } from "../api";
import { Member } from "../api/types/Members";

export function makeName(person: { firstName: string; lastName: string }) {
  return `${person.firstName} ${person.lastName}`;
}

export function makeMemberMap(members: Array<Member>) {
  const membersMap = new Map<string, Member>();
  for (const member of members) {
    membersMap.set(makeName(member), member);
  }
  return membersMap;
}

export async function useMemberArray(
  setLoaded?: (loaded: boolean) => void,
  canLoad?: boolean
) {
  let isCanceled = false;
  const [members, setMembers] = useState<Array<Member>>([]);

  const getMembers = async () => {
    try {
      const membersList = await Api.members.getMembers();
      if (!isCanceled) {
        setMembers(membersList.data);
        if (setLoaded) setLoaded(true);
      }
    } catch (error) {
      console.error("Member Array:", error);
    }
  };

  useEffect(() => {
    if (canLoad) getMembers();
    return () => {
      isCanceled = true;
    };
  }, []);
  return members;
}

export function useMemberList() {
  let isCanceled = false;
  const [members, setMembers] = useState<Map<string, Member>>(new Map());

  const getMembers = async () => {
    try {
      const membersList = await Api.members.getMembers();
      const names = makeMemberMap(membersList.data);
      if (!isCanceled) {
        setMembers(names);
      }
    } catch (error) {
      console.error("Update Team:", error);
    }
  };

  useEffect(() => {
    getMembers();
    return () => {
      isCanceled = true;
    };
  }, []);
  return members;
}
